import { Menu, MenuItem, MenuList } from "@chakra-ui/react";
import { BiPencil, BiTrashAlt } from "react-icons/bi";
import { RiListSettingsLine } from "react-icons/ri";
import { ComponentRequireRole } from "../../../components/component-require-role";
import { PaddedIcon } from "../../../components/ui/button/Icon";
import Workspace from "../../../components/workspace";
import { roleMap } from "../../../config/roleMapping";

const { pastoralCareDirectorate, residentPastor } = roleMap;

const Group = ({ group, formModal, deleteGroupDialog, setSelected, manageGroupModal }) => {
   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(group);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <p className="col-span-3 font-bold overflow-hidden overflow-ellipsis">{`${group.name}`}</p>
               <p className="col-span-4 text-sm">{group.description}</p>
               <p className="col-span-3">{group.groupType.name}</p>
               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary" aria-label="edit">
                     <BiPencil className="text-lg" />
                  </PaddedIcon>

                  <Menu>
                     <Workspace.ItemMenuButton />
                     <MenuList className="!py-4">
                        <ComponentRequireRole requiredRoles={[pastoralCareDirectorate, residentPastor]}>
                           <>
                              <MenuItem
                                 className="flex gap-2 !py-3"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    setSelected(group);
                                    manageGroupModal.onOpen();
                                 }}>
                                 <RiListSettingsLine /> Manage members
                              </MenuItem>
                              <MenuItem
                                 className="flex gap-2 !py-3 !text-red-600"
                                 onClick={(e) => {
                                    setSelected(group);
                                    e.stopPropagation();
                                    deleteGroupDialog.onOpen();
                                 }}>
                                 <BiTrashAlt /> Delete
                              </MenuItem>
                           </>
                        </ComponentRequireRole>
                     </MenuList>
                  </Menu>
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export default Group;
